export default __webpack_public_path__ + "static/media/story-SLIDE_9.4e24e7fa.jpg";